export default __webpack_public_path__ + "static/media/In Late Afternoon - 40s sample.05aedc85.mp3";